import { Redirect } from 'expo-router'
import { useSession } from '~/components/user/SessionProvider'

export default function Index() {
  const { session, isLoading, isAnonymous } = useSession()
  const shouldRedirectToAuthenticated = !!session?.user && !isLoading && !isAnonymous

  if (shouldRedirectToAuthenticated) {
    return <Redirect href="/(authenticated)" />
  }

  return <Redirect href="/login" />
}
